import axios from 'axios';
import React, { Component } from 'react';
import Col from 'react-bootstrap/lib/Col';
import Image from 'react-bootstrap/lib/Image';
import Row from 'react-bootstrap/lib/Row';
import { Link } from 'react-router-dom';
import Title from '../objs/Title';
import './Artists.css';

let back = 'https://backend.themusiccompany.dk';

class Artist extends Component {
  render() {
    return (
      <Col xs={12} sm={4} md={2} lg={2}>
        <div className="bandDiv">
          <Image
            alt={this.props.obj.name}
            className="bandImage"
            responsive
            src={this.props.obj.image.thumb}
          />
          <div className="bandName">{this.props.obj.name}</div>
        </div>
      </Col>
    );
  }
}

class Artists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      booker: null,
      mgmt: [],
    };
  }

  componentDidMount() {
    axios.get(back + '/allartists/?format=json').then((res) => {
      const books = res.data.map((obj) => {
        if (obj.type === 'Booking' || obj.type === 'Both') {
          return (
            <Link
              to={'/book/' + obj.name + '?type=' + this.props.type}
              key={obj.id}
            >
              <Artist obj={obj} />
            </Link>
          );
        }
        return null;
      });
      const mgmt = res.data.map((obj) => {
        if (obj.type === 'MGMT' || obj.type === 'Both') {
          return (
            <Link
              to={'/book/' + obj.name + '?type=' + this.props.type}
              key={obj.id}
            >
              <Artist obj={obj} />
            </Link>
          );
        }
        return null;
      });
      this.setState({ booker: books, mgmt: mgmt });
    });
  }

  render() {
    return (
      <div>
        {this.props.type === 'management' ? (
          <Row className="management artists">
            <Title title="management" style={{ color: '#2d2d2d' }} />
            <div className="artistwrap">{this.state.mgmt}</div>
          </Row>
        ) : (
          <Row
            className="booking artists"
            style={{
              minHeight: this.state.booker ? 'auto' : 'calc(100vh - 100px)',
            }}
          >
            <Title title="booking" style={{ color: '#2d2d2d' }} />
            <div className="artistwrap">{this.state.booker}</div>
          </Row>
        )}
      </div>
    );
  }
}

export default Artists;



// WEBPACK FOOTER //
// ./src/main/Artists.js